/* global Vue, PREFIX */

import { Notifications, setErrorAndStopLoading } from '../apps/components/Notifications'
import AuthService from '../AuthService'
import { AppError, ErrorLevel } from '../classes/Errors'
import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'

const i18n = CreateI18n(messagesSpecific)

const ActivateUuidApp = Vue.createApp({
  name: 'ActivateUuidApp',
  components: { Notifications },
  template: '<Notifications />',
  setup () {
    Vue.onMounted(() => {
      const dmdUniqueUserId = (new URLSearchParams(window.location.search)).get('DMD_uniqueUserId')
      if (window.sessionStorage.getItem('DMD_activating')) {
        setTimeout(() => {
          window.sessionStorage.removeItem('DMD_activating')
          window.location.href = `${PREFIX}/`
        }, 2000)
      } else if (dmdUniqueUserId) {
        window.localStorage.setItem('DMD_uniqueUserId', dmdUniqueUserId)
        AuthService.clearBrowserStorage()
        window.sessionStorage.setItem('DMD_activating', true)
        AuthService.openLoyaltyActivation()
      } else {
        setErrorAndStopLoading(new AppError('no-uuid', ErrorLevel.FATAL))
      }
    })
  },
})

const appElement = document.getElementById('activate-uuid-app')

if (appElement) {
  ActivateUuidApp.use(i18n)
  ActivateUuidApp.mount(appElement)
}

export default ActivateUuidApp
